import { types } from '../../types/types'
import CredencialesService from '../../services/CredencialesService'
import AfiliadoService from '../../services/AfiliadoService'

import { startAlerta } from '../ui/alertas'

export const getDataPersonal = (idAfiliado) => async (dispatch) => {
    dispatch({ type: types.traerDataPersonalStart })
    try {
        const result = await AfiliadoService.getDataAfiliadoFromAfiliaciones(idAfiliado)
        const body = await result.json()
        if (result.ok) {
            dispatch({
                type: types.traerDataPersonalSuccess,
                payload: body
            })
        } else {
            throw body.errores
        }

    } catch (error) {
        dispatch({ type: types.traerDataPersonalError })
        console.log("Error al traer la data personal del afiliado", error)
        if (error.mensaje) {
            dispatch(startAlerta(error.mensaje, "error"))
        } else {
            dispatch(startAlerta("Ha ocurrido un error. Intente nuevamente.", "error"))
        }
    }
}

export const getCredenciales = (idAfiliado=null) => async (dispatch) => {
    dispatch({ type: types.traerCredencialesStart })
    // Esta funcion se usa para autogestion y para el sistema, si le van a agregar mucha logica, sea cualquiera de los lados, separen la logica en dos funciones
    try {
        let result;

        if(idAfiliado){
            result= await CredencialesService.getCredencialesByIdAfiliado(idAfiliado)
        }else{
            result= await CredencialesService.getCredenciales()
        }

        const body = await result.json()
        if (result.ok) {
            dispatch({
                type: types.traerCredencialesSuccess,
                payload: body
            })
        } else {
            throw body.errores
        }

    } catch (error) {
        dispatch({ type: types.traerCredencialesError })
        console.log("Error al traer las credenciales", error)
        if (error.mensaje) {
            dispatch(startAlerta(error.mensaje, "error"))
        } else {
            dispatch(startAlerta("Ha ocurrido un error. Intente nuevamente.", "error"))
        }
    }
}

export const enviarCredencialesAfiliado=(idAfiliado)=>async (dispatch)=>{
    // dispatch({ type: types.traerCredencialesStart })
    try {
        let result= await AfiliadoService.enviarCredencialesAcceso(idAfiliado)

        const body = await result.json()
        if (result.ok) {
            dispatch(startAlerta(`¡Credenciales de acceso enviadas!`,'success','Comando Exitoso'));
        } else {
            throw body.errores
        }

    } catch (error) {
        console.log("Error al enviar las credenciales de acceso", error)
        if (error.mensaje) {
            dispatch(startAlerta(error.mensaje, "error"))
        } else {
            dispatch(startAlerta("Ha ocurrido un error. Intente nuevamente.", "error"))
        }
    }
}

export const changeStepTurnos = (step) => async (dispatch) => {
    dispatch({
        type: types.changeStepperTurnoAfiliado,
        payload: step
    })
}